import { render, staticRenderFns } from "./studentRestList.vue?vue&type=template&id=aa1c22d0&scoped=true&"
import script from "./studentRestList.vue?vue&type=script&lang=js&"
export * from "./studentRestList.vue?vue&type=script&lang=js&"
import style0 from "./studentRestList.vue?vue&type=style&index=0&id=aa1c22d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1c22d0",
  null
  
)

export default component.exports